import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { OptionImagePipe } from '@df/ui/common/option-image.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';

@Component({
    selector: 'recommendation-item',
    templateUrl: './recommendation-item.html',
    standalone: true,
    imports: [ImageModule, OptionImagePipe, OptionLabelPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecommendationItemDataComponent {
    @Input({
        required: true
    })
    recommendation!: number;
}
